import React from "react";
import { Link } from "react-router-dom";

import Tree from "@naisutech/react-tree";

class SidebarNavItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentWillUnmount() {}

  componentDidMount() {}

  render() {
    const { sidebarNavItems } = this.props;

    return (
      <div className="nav-wrapper">
        <Tree nodes={sidebarNavItems} NodeRenderer={TreeNodeComponent} />
        <NavItemComponent label="Users" path="/view-users" />
        {/* <NavItemComponent label="Batch Report" path="/batch-report" /> */}
        {/* {(controls) => {
            return (
              <button
                onClick={() => {
                  controls.toggleNodeSelection("629e1d0725daaa3d34d49bac");
                  controls.toggleOpenCloseNode("629e1d0725daaa3d34d49bac");
                }}
              >
                Open/close all nodes
              </button>
            );
          }} */}
      </div>
    );
  }
}

const TreeNodeComponent = (props) => {
  const { data } = props;
  const nodeClasses = ["tree-node"];
  nodeClasses.push("level-" + data.level);
  const trnd_icon = !data.hasChild ? "" : props.isOpen ? "remove" : "add";

  return (
    <div className={nodeClasses.join(" ")}>
      {trnd_icon ? <i className="material-icons trnd-icon">{trnd_icon}</i> : <></>}
      <Link to={data.path} className="trnd-link">
        {data.label}
      </Link>
    </div>
  );
};

const NavItemComponent = (props) => {
  const { label, path } = props;
  const nodeClasses = ["tree-node"];

  return (
    <div className={nodeClasses.join(" ")}>
      <Link to={path} className="trnd-link">
        {label}
      </Link>
    </div>
  );
};

export default SidebarNavItems;
